module.exports = __webpack_public_path__ + "static/media/W19-1154_AW_BMAwareness_Desktop_2396x1473_EN.f21c1818.jpg";